import * as THREE from "three";
import Experience from "../Experience.js";

export default class Notebook {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("Notebook");
    }

    // Resource
    this.resource = this.resources.items.notebookModel;

    this.setModel();
  }

  setModel() {
    this.model = this.resource.scene;
    this.model.position.set(0.93, -0.35, 0.35);
    this.model.rotateY(-0.4);
    this.model.name = "notebook";

    this.notebookScreen = this.model.children;
    this.notebookScreen[0].children[4].children[1].material.color.encoding = THREE.sRGBEncoding
    this.notebookScreen[0].children[4].children[1].material.map = this.resources.items.notebookBackgroundTexture;
    this.notebookScreen[0].children[4].children[1].material.map.flipY = true;
    this.notebookScreen[0].children[4].children[1].material.color.set('white');
  
    this.scene.add(this.model);

    this.model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.name = this.model.name;
      }
    });
  }
}
